import React from "react";
import { useNavigate } from "react-router-dom";
import "./legal.style.css";

const SECTIONS = [
  {
    number: "1",
    title: "About UALIGN",
    body: "UALIGN provides digital orthodontic treatment planning, clear aligner manufacturing, case management tools, and related digital services for licensed dental professionals. UALIGN may also provide a patient-facing mobile application and QR-based access tools to help patients follow aligner instructions, reminders, and treatment progress.\n\nUALIGN does not provide dental diagnosis directly to patients. Treatment decisions remain the responsibility of the prescribing dentist, orthodontist, or licensed dental professional.",
  },
  {
    number: "2",
    title: "Acceptance of these Terms",
    body: "By accessing or using the UALIGN website, dentist portal, patient app, QR code services, case submission system, digital treatment planning tools, or any related service, you agree to these Terms of Use.\n\nIf you do not agree, you must not use our services.",
  },
  {
    number: "3",
    title: "Who may use UALIGN",
    body: "UALIGN services are intended for licensed dentists, orthodontists, dental clinics, dental laboratories, authorised distributors, approved business partners, and patients invited by their dentist or clinic to use the UALIGN patient app or QR-based patient access system.\n\nPatients must only use UALIGN under the care and supervision of their treating dental professional.",
  },
  {
    number: "4",
    title: "No direct dental advice to patients",
    body: "Information provided through UALIGN, including treatment reminders, aligner wear instructions, app notifications, educational materials, and website content, is general support information only. It does not replace professional dental advice, diagnosis, treatment planning, emergency care, or clinical judgement.\n\nPatients should contact their treating dentist if they experience pain, poor aligner fit, broken aligners, gum irritation, tooth mobility, allergic reaction, or any other concern.",
  },
  {
    number: "5",
    title: "Dentist responsibility",
    body: "The prescribing dentist or clinic is responsible for confirming patient suitability for clear aligner treatment; obtaining patient consent; reviewing scans, records, treatment plans, IPR, attachments, staging, and clinical instructions; approving treatment setups before manufacturing; monitoring treatment; managing refinements, complications, emergency visits, and final retention; and ensuring that UALIGN products are used according to applicable clinical, legal, and regulatory requirements.\n\nUALIGN may assist with digital planning and manufacturing, but final clinical responsibility remains with the treating dental professional.",
  },
  {
    number: "6",
    title: "Patient responsibility",
    body: "Patients using UALIGN aligners or the UALIGN app must follow the instructions given by their treating dentist; wear aligners only as prescribed; change aligners only according to professional instructions; keep aligners clean and stored safely; avoid unsafe cleaning methods; contact their dentist if aligners do not fit properly, are damaged, or cause unusual symptoms; and avoid sharing QR codes, accounts, or treatment information with unauthorised people.",
  },
  {
    number: "7",
    title: "Account registration and security",
    body: "Some UALIGN services require an account. You agree to provide accurate information and keep your login details secure.\n\nYou are responsible for all activity under your account unless caused by UALIGN's failure to take reasonable security measures.\n\nYou must notify us immediately if you suspect unauthorised access.",
  },
  {
    number: "8",
    title: "Case submission and uploaded content",
    body: "Dentists and clinics may upload patient records, including intraoral scans, STL/PLY/GLB files, photographs, X-rays, CBCT files, prescriptions, treatment preferences, and notes.\n\nBy uploading case content, you confirm that you have the right and authority to submit the content; you have obtained all necessary patient consent; the information is accurate and clinically appropriate; the uploaded files do not infringe third-party rights; and the case does not contain unlawful, misleading, or unnecessary personal data.",
  },
  {
    number: "9",
    title: "Digital treatment plans",
    body: "UALIGN may provide digital treatment simulations, staging, trimline designs, attachments, IPR suggestions, reports, and related planning outputs.\n\nThese are planning aids only and must be reviewed and approved by the treating dentist before aligners are manufactured or used.\n\nUALIGN does not guarantee a specific clinical outcome, tooth movement, treatment time, or final result.",
  },
  {
    number: "10",
    title: "Manufacturing and product use",
    body: "UALIGN aligners are custom-made devices produced according to the case data and approved treatment plan supplied by the dentist or clinic.\n\nThe dentist must check the fit, suitability, instructions, and patient compliance during treatment.\n\nUALIGN products must not be altered, resold, reused by another patient, or used outside the approved treatment plan.",
  },
  {
    number: "11",
    title: "App reminders and notifications",
    body: "The UALIGN app may provide reminders, notifications, aligner change prompts, wear-time guidance, and educational messages.\n\nThese reminders are supportive only. They do not replace instructions from the treating dentist. If there is any conflict between the app and the dentist's instructions, the dentist's instructions should be followed.",
  },
  {
    number: "12",
    title: "Acceptable use",
    body: "You must not use UALIGN for unlawful, unsafe, fraudulent, or unauthorised purposes; upload malicious files, viruses, or harmful code; attempt to access another user's account or patient data; reverse engineer, copy, modify, or misuse UALIGN software or designs; use UALIGN to provide treatment if you are not legally authorised to do so; submit false, misleading, or clinically unsafe information; or use UALIGN branding without written permission.",
  },
  {
    number: "13",
    title: "Intellectual property",
    body: "All UALIGN names, logos, designs, software, reports, treatment planning tools, app interfaces, graphics, text, workflows, and other materials belong to UALIGN or its licensors.\n\nYou may not copy, reproduce, distribute, modify, or create derivative works from UALIGN materials without written permission.\n\nDentists and clinics retain responsibility for their own uploaded patient records, but grant UALIGN the limited right to use them to provide the requested services.",
  },
  {
    number: "14",
    title: "Third-party services",
    body: "UALIGN may use third-party platforms for hosting, payment processing, communication, analytics, cloud storage, app distribution, and technical support.\n\nUALIGN is not responsible for third-party websites or services that are outside our control.",
  },
  {
    number: "15",
    title: "Availability of services",
    body: "We aim to keep UALIGN services available and secure, but we do not guarantee uninterrupted access. Services may be unavailable due to maintenance, updates, technical problems, security issues, or events outside our control.",
  },
  {
    number: "16",
    title: "Limitation of liability",
    body: "To the maximum extent permitted by law, UALIGN is not liable for clinical decisions made by dentists or clinics; patient non-compliance; inaccurate scans, incomplete records, or incorrect prescriptions; treatment outcomes that differ from simulations; delays caused by incomplete information, shipping, customs, third-party services, or force majeure; loss of profit, business interruption, or indirect loss.\n\nNothing in these Terms limits liability that cannot legally be limited, including liability for death or personal injury caused by negligence, fraud, or any other liability that cannot be excluded under applicable law.",
  },
  {
    number: "17",
    title: "Suspension or termination",
    body: "We may suspend or terminate access to UALIGN services if we believe a user has breached these Terms, created a security risk, submitted unsafe or unlawful content, failed to pay fees, or misused the platform.",
  },
  {
    number: "18",
    title: "Changes to these Terms",
    body: "We may update these Terms from time to time. The latest version will be published on our website or app. Continued use of UALIGN after changes means you accept the updated Terms.",
  },
  {
    number: "19",
    title: "Governing law",
    body: "These Terms are governed by the laws of England and Wales, unless otherwise required by applicable local law.\n\nThe courts of England and Wales shall have jurisdiction, except where mandatory law gives you the right to bring a claim elsewhere.",
  },
  {
    number: "20",
    title: "Contact",
    body: "UALIGN LTD\nCompany number: 17062684\nRegistered in England and Wales\nRegistered office: 128, City Road, London, EC1V 2NX, UNITED KINGDOM\nEmail: info@ualign.co.uk\nPhone: +44 7537 135002\nWebsite: https://ualign.co.uk",
  },
];

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <button className="legal-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>
      </header>

      <main className="legal-content">
        <div className="legal-meta">
          <p className="legal-meta-item"><strong>Company:</strong> UALIGN LTD</p>
          <p className="legal-meta-item"><strong>Effective date:</strong> 1 January 2026</p>
          <p className="legal-meta-item"><strong>Email:</strong> info@ualign.co.uk</p>
        </div>

        <h1 className="legal-title">Terms of Use</h1>
        <p className="legal-subtitle">
          Website, dentist portal, patient app and digital aligner services
        </p>

        {SECTIONS.map((section) => (
          <section key={section.number} className="legal-section">
            <h2 className="legal-section-title">
              {section.number}. {section.title}
            </h2>
            {section.body.split("\n\n").map((para, i) => (
              <p key={i} className="legal-para">
                {para}
              </p>
            ))}
          </section>
        ))}
      </main>
    </div>
  );
};

export default TermsOfService;
